<div class="tinymce-editor-container">

  <!-- LOADING STATE -->
  <div *ngIf="!isEditorInitialized" class="editor-loading">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Cargando editor...</span>
  </div>

  <!-- EDITOR -->
  <editor
    #editor
    id="tinymce-editor-{{tabId}}"
    [init]="editorConfig"
    (onInit)="onEditorInit($event)"
    (onInput)="onContentChange($event)"
    [class.editor-ready]="isEditorInitialized">
  </editor>


    <!-- <editor
    #editor
    id="tinymce-editor-{{tabId}}"
    [init]="editorConfig"
    [value]="currentTab?.contenido || ''"
    (onInit)="onEditorInit($event)"
    (onInput)="onContentChange($event)"
    [class.editor-ready]="isEditorInitialized">
  </editor> -->

  <!-- EDITOR STATUS BAR -->
  <div class="editor-status" *ngIf="currentTab && isEditorInitialized">
    <div class="status-left">
      <span class="tab-type">
        {{ currentTab.tipo === 'escrito' ? 'Escrito' : 'Plantilla' }}
      </span>

      <span class="tab-status" [class.modified]="currentTab.hasChanges">
        {{ currentTab.hasChanges ? 'Modificado' : 'Guardado' }}
      </span>
    </div>

    <div class="status-center">
      <span class="tab-title">{{ currentTab.titulo }}</span>
    </div>

    <div class="status-right">
      <span class="last-saved" *ngIf="currentTab.lastSaved">
        Último guardado: {{ formatTime(currentTab.lastSaved) }}
      </span>

      <button
        mat-icon-button
        class="status-btn"
        (click)="saveCurrentTab()"
        [disabled]="!currentTab.hasChanges"
        matTooltip="Guardar (Ctrl+S)">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </div>
</div>
